import React, { Fragment, useState } from "react";
import { BsThreeDots } from "react-icons/bs";
import { Redirect } from "react-router";
import Dropdown from "rc-dropdown";
import Menu, { Item as MenuItem } from "rc-menu";
import "rc-dropdown/assets/index.css";

import "./user.scss";

const User = (props) => {
  const [redirect, setRedirect] = useState(false);
  const account = props.user;

  const handleClick = (id) => {
    setRedirect(true);
  };
  const menuItems = [
    <MenuItem
      key="1"
      onClick={() => handleClick(account.id)}
      style={{ cursor: "pointer" }}
    >
      Send Email
    </MenuItem>,
  ];

  const menu = <Menu className="menu">{menuItems}</Menu>;
  return (
    <Fragment>
      <div className="user-desktop">
        <div className="action-icon">
          <Dropdown
            className="dropdown-for-send"
            overlay={menu}
            overlayClassName="overlay-class"
          >
            <button>
              <BsThreeDots style={{ cursor: "pointer" }} />
            </button>
          </Dropdown>
        </div>
        <div className="account-image-row mx-auto d-flex">
          <div className="wrapper d-flex align-items-center">
            <div className="image-container d-flex justify-content-center align-items-center">
              <div className="first-letter">
                {`${account.first_name_en ? account.first_name_en[0] : ""} ${
                  account.last_name_en ? account.last_name_en[0] : ""
                }`}
              </div>
            </div>
            <div className="name-container">
              {`${account.first_name_en ? account.first_name_en : ""} ${
                account.last_name_en ? account.last_name_en : ""
              }`}
            </div>
          </div>
        </div>
        <div className="detail-row w-100 d-flex flex-column">
          <div className="detail d-flex justify-content-between align-items-center">
            <div className="label">First Name:</div>
            <div className="value">{account.first_name_en}</div>
          </div>
          <div className="detail d-flex justify-content-between align-items-center">
            <div className="label">Last Name:</div>
            <div className="value">{account.last_name_en}</div>
          </div>
          <div className="detail d-flex justify-content-between align-items-center">
            <div className="label">Email:</div>
            <div className="value lower-case">{account.email}</div>
          </div>
        </div>
      </div>
      {redirect && (
        <Redirect
          push
          to={{
            pathname: "/vendor/send-email",
            state: { name: "send-email", email: account.email },
          }}
        />
      )}
    </Fragment>
  );
};

export default User;
